export default ()=>({
    newOrders : null,
    getOrdersInProcess: null,
    getOrderEnRuta: null,
    publicKeyPush: null,
    coord: {lat:'',lng:''}
})
    